type TusLocalStorageEntry = {
  creationTime: string;
  metadata: { [key: string]: string };
  size: number;
  uploadUrl: string;
};

const TUS_LS_PREFIX = 'tus::tus';

const storage = {
  getItem: (key: string) => localStorage.getItem(key),
  getKeys: (keyStartsWith: string) => Object.keys(localStorage).filter((key) => key.startsWith(keyStartsWith)),
  removeItem: (key: string) => localStorage.removeItem(key),
};

const getEntries = (keys: string[]) => {
  return keys.map((key) => {
    const entry = storage.getItem(key) as string;

    return JSON.parse(entry) as TusLocalStorageEntry;
  });
};

const clearAll = () => {
  const keys = storage.getKeys(TUS_LS_PREFIX);

  keys.forEach((key) => {
    storage.removeItem(key);
  });
};

const isEntryExpired = (entry: TusLocalStorageEntry) => {
  const TWO_MONTHS_IN_MS = 1000 * 60 * 60 * 24 * 60;

  const today = Date.now();

  const creationDate = new Date(entry.creationTime).getTime();
  const timeDifference = today - creationDate;

  return timeDifference > TWO_MONTHS_IN_MS;
};

const clearExpired = () => {
  const keys = storage.getKeys(TUS_LS_PREFIX);

  if (keys.length === 0) {
    return;
  }

  const entries = getEntries(keys);

  entries.forEach((entry, idx) => {
    if (isEntryExpired(entry)) {
      storage.removeItem(keys[idx]);
    }
  });
};

export const clearTusLSEntries = {
  all: clearAll,
  expired: clearExpired,
};
